import { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { AppContext } from '../../context/app'
import { SubscriptionContext } from '../../context/subscription'
import { getTemplateRoutes } from './templateFunctions'
import ProfileIcon from '../../assets/profile-icon.png'
import LeftArrow from '../../assets/left-arrow.svg'
import RightArrow from '../../assets/right-arrow.svg'
import PlusIcon from '../../assets/plus-icon.svg'
import EditIcon from '../../assets/edit-icon.svg'
import TrashIcon from '../../assets/trash-icon.svg'
import VideoPlaceholder from '../../assets/video-content.png'
import UpArrow from '../../assets/up-arrow.svg'
import DownArrow from '../../assets/down-arrow.svg'
import FitnessPrev from '../../assets/fitness-prev-icon.svg'
import FitnessNext from '../../assets/fitness-next-icon.svg'
import SmallLiveImage from '../../assets/live-image.png'
import PrevArrow from '../../assets/prev-arrow-no-outline.svg'
import NextArrow from '../../assets/next-arrow-no-outline.svg'
import PrevArrowIkim from '../../assets/prev-arrow-ikim.png'
import NextArrowIkim from '../../assets/next-arrow-ikim.png'
import BannerPlaceholder from '../../assets/banner.jpg'

import FBLogo from '../../assets/social/facebook-logo.png'
import InstaLogo from '../../assets/social/instagram-logo-white.png'
import TGLogo from '../../assets/social/telegram-white.png'
import YTLogo from '../../assets/social/youtube-white.png'
import TwitterLogo from '../../assets/social/twitter-white.svg'
import BitchuteLogo from '../../assets/social/bitchute-white-logo.png'
import RumbleLogo from '../../assets/social/rumble.png'
import BoxcastLogo from '../../assets/social/boxcast-icon.png'
import TikTokLogo from '../../assets/social/tiktok-white.png'
import EmailIcon from '../../assets/email-icon.svg'
import BasicPlaceholder from '../../assets/basic-placehoder.jpg'
import PhoneIcon from '../../assets/phone-icon.svg'

import SearchIconBlue from '../../assets/search-icon-blue.svg'
import SearchIconWhite from '../../assets/search-icon-white.svg'
import HamburgerIcon from '../../assets/hamburger-icon-white.svg'
import UIMediaStarLogo from '../../assets/profile-icon-red.svg'
import { getExternalLink } from './templateFunctions'
import { LG_SIZE, SM_SIZE, XL_SIZE, XXL_SIZE } from '../../utils/constants'
import {
  CONTENT_FILTERING,
  ARTIST_LISTING,
  VENUE_LISTING,
  INTERNAL_ASSET_API,
  LOGIN_API,
  SIGNUP_API,
  CUSTOM_FORM,
  PRODUCT_FILTER_API_V2,
  IPTV_CHANNEL_FILTER,
} from '../../utils/apiUrls'
import FBDefaultLogo from '../../assets/social/facebook-default.png'
import ThreadsIcon from '../../assets/social/threads-icon.png'
import InstaDefaultLogo from '../../assets/social/instagram-default.png'
import TGDefaultLogo from '../../assets/social/telegram-default.png'
import YTDefaultLogo from '../../assets/social/youtube-default-icon.svg'
import TwitterDefaultLogo from '../../assets/social/twitter-default.svg'
import BitchuteDefaultLogo from '../../assets/social/bitchute-default.png'
import RumbleDefaultLogo from '../../assets/social/rumble-default.png'
import BoxcastDefaultLogo from '../../assets/social/boxcast-default.png'
import TikTokDefaultLogo from '../../assets/social/tik-tok-icon.svg'
import DMCALogo from '../../assets/DMCA_Logo.png'
import {
  convertDuration,
  getReleaseDate,
  PAGE_SIZE,
  raiseToast,
  viewsFormatter,
  getRandomBgGradient,
  getProductImage,
} from '../../utils/helper'
import PlaylistPlayer from '../../container/player/playlistPlayer'
import Player from '../../container/player/player'
import ChannelPlayer from '../../container/player/channelPlayer'
import TrailerPlayer from '../../container/player/trailerPlayer'
import PlayIcon from '../../assets/play-circle.svg'
import AndroidStore from '../../assets/mobileApps/androidStore.png'
import AppleStore from '../../assets/mobileApps/appleStore.png'
import AndroidTv from '../../assets/tvAppIcons/androidTv.png'
import AppleTv from '../../assets/tvAppIcons/appleTv.png'
import RokuTv from '../../assets/tvAppIcons/rokuTv.png'
import FireTv from '../../assets/tvAppIcons/fireTv.png'
import SamsungTv from '../../assets/tvAppIcons/samsungTv.png'
import LGTv from '../../assets/tvAppIcons/LGTv.png'
import SquareDummyImg from '../../assets/square-dummy-img.png'
import PortraitDummyImg from '../../assets/potrait-dummy-img.png'
import ThumbsUpIcon from '../../assets/thumbs-up-icon.svg'
import SquareDraftIcon from '../../assets/sqaure-draft-icon.svg'
import SquareShareIcon from '../../assets/share-square-icon.svg'
import FacebookIcon from '../../assets/imgComponents/facebookIcon'
import XIcon from '../../assets/imgComponents/xIcon'
import YoutubeIcon from '../../assets/imgComponents/youtubeIcon'
import TelegramIcon from '../../assets/imgComponents/telegramIcon'
import InstagramIcon from '../../assets/imgComponents/instagramIcon'
import LinkedinIcon from '../../assets/social/linkedin-icon.png'
import RednoteIcon from '../../assets/social/rednote-icon.png'
import TriangleIcon from '../../assets/triangle.svg'
import KalingoLeftArrow from '../../assets/kalingo-left-arrow.svg'
import KalingoRightArrow from '../../assets/kalingo-right-arrow.svg'
import AudioIcon from '../../assets/audio-content-badge.svg'

const useTemplateHook = () => {
  const navigate = useNavigate()
  const {
    isLogin,
    userObj,
    logoutCall,
    accountObj,
    setLanguageModal,
    isBrowser,
    setPopupModalLink,
    setPopUpTitle,
    setLoader,
    setOpenForgotPasswordModal,
    setUser,
    setOpenLoginModal,
    athleteHeaderData,
    setAthleteHeaderData,
  } = useContext(AppContext)
  const { setOpenSubscriptionModal, setSubscriptions, setContentPartners } =
    useContext(SubscriptionContext)
  const location = useLocation()

  const handleRedirect = (type, linkObj, isEdit, popUpTitle = '', samePageRedirection = false) => {
    if (isEdit) return
    if (type === 'DIRECT') {
      navigate(linkObj)
      return
    }
    if (!linkObj?.type) return

    if (linkObj?.type === 'EXTERNAL') {
      const url = linkObj?.data?.url.includes('http')
        ? linkObj?.data?.url
        : `http://${linkObj?.data?.url}`

      if (linkObj.data?.popup_enabled) {
        setPopupModalLink(url)
        setPopUpTitle(popUpTitle)
        return
      }

      if (samePageRedirection) {
        window.location.replace(url)
      } else {
        window.open(url, '_blank')
      }

      return
    }
    navigate(getTemplateRoutes(linkObj))
  }
  const getLinkUrl = (linkObj) => {
    if (!linkObj?.type) return

    if (linkObj?.type === 'EXTERNAL') {
      const url = linkObj?.data?.url.includes('http')
        ? linkObj?.data?.url
        : `http://${linkObj?.data?.url}`

      if (linkObj.data?.popup_enabled) {
        setPopupModalLink(url)
        setPopUpTitle('')
        return
      }

      return url
    }
    return getTemplateRoutes(linkObj)
  }

  const checkActiveClass = (linkObj, isEdit) => {
    if (isEdit || !linkObj?.type || linkObj?.type === 'EXTERNAL') return false
    return getTemplateRoutes(linkObj) === window.location.href.replace(window.location.origin, '')
  }

  const getTemplateImage = (s3Key) => {
    if (!s3Key) return
    if (s3Key.includes('common-template-assets') || s3Key.includes('common-template-asstes')) {
      if (s3Key.includes('common-template-asstes')) {
        let imgPath = s3Key.split('/')
        return `${INTERNAL_ASSET_API}/public/common-template-assets/` + imgPath[2]
      }

      return INTERNAL_ASSET_API + '/' + s3Key
    }
    return accountObj?.cf_domain_name + '/' + s3Key
  }

  const handleSubscription = () => {
    setContentPartners([])
    setSubscriptions([])
    setOpenSubscriptionModal(true)
  }

  const fitnessHeaderPadding = !(location.pathname === '/' || location.pathname === '/home')

  return {
    customNavigate: handleRedirect,
    checkActiveClass,
    isLogin,
    setOpenLoginModal,
    userObj,
    logoutCall,
    setLanguageModal,
    handleSubscription,
    getTemplateImage,
    ProfileIcon,
    LeftArrow,
    RightArrow,
    PlusIcon,
    EditIcon,
    TrashIcon,
    VideoPlaceholder,
    fitnessHeaderPadding,
    UpArrow,
    DownArrow,
    FitnessPrev,
    FitnessNext,
    SmallLiveImage,
    PrevArrow,
    NextArrow,
    PrevArrowIkim,
    NextArrowIkim,
    isBrowser,
    BannerPlaceholder,
    FBLogo,
    InstaLogo,
    TGLogo,
    YTLogo,
    TwitterLogo,
    BitchuteLogo,
    RumbleLogo,
    BoxcastLogo,
    TikTokLogo,
    EmailIcon,
    BasicPlaceholder,
    PhoneIcon,
    SearchIconBlue,
    SearchIconWhite,
    HamburgerIcon,
    UIMediaStarLogo,
    getExternalLink,
    LG_SIZE,
    SM_SIZE,
    XL_SIZE,
    XXL_SIZE,
    CONTENT_FILTER_XAVIER: CONTENT_FILTERING,
    IPTV_CHANNEL_FILTER_XAVIER: IPTV_CHANNEL_FILTER,
    PRODUCT_FILTER_API_V2,
    CUSTOM_FORM,
    ARTIST_LISTING,
    VENUE_LISTING,
    FBDefaultLogo,
    ThreadsIcon,
    InstaDefaultLogo,
    TGDefaultLogo,
    YTDefaultLogo,
    TwitterDefaultLogo,
    BitchuteDefaultLogo,
    RumbleDefaultLogo,
    BoxcastDefaultLogo,
    TikTokDefaultLogo,
    LinkedinIcon,
    RednoteIcon,
    DMCALogo,
    viewsFormatter,
    Player,
    PlaylistPlayer,
    ChannelPlayer,
    TrailerPlayer,
    PlayIcon,
    isMultilingual: accountObj?.allowed_languages
      ? accountObj?.allowed_languages.length > 1
      : false,
    AndroidStore,
    AppleStore,
    AndroidTv,
    AppleTv,
    RokuTv,
    FireTv,
    SamsungTv,
    LGTv,
    setLoader,
    setOpenForgotPasswordModal,
    setUser,
    LOGIN_API,
    SIGNUP_API,
    CategoryDummyImg: '',
    PAGE_SIZE,
    raiseToast,
    SquareDummyImg,
    PortraitDummyImg,
    ThumbsUpIcon,
    SquareDraftIcon,
    SquareShareIcon,
    convertDuration,
    getReleaseDate,
    playerPageAllowed: accountObj?.od_resource_allowances?.player_page,
    FacebookIcon,
    XIcon,
    YoutubeIcon,
    TelegramIcon,
    InstagramIcon,
    getLinkUrl,
    getRandomBgGradient,
    TriangleIcon,
    getProductImage,
    isStorePage: window.location.href.includes('/store'),
    KalingoLeftArrow,
    KalingoRightArrow,
    AudioIcon,
    athleteHeaderData,
    setAthleteHeaderData,
  }
}

export default useTemplateHook
